/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceAdminDocumentsByTypeResource } from './';
import {
    ComplianceAdminDocumentsByTypeResourceFromJSON,
    ComplianceAdminDocumentsByTypeResourceFromJSONTyped,
    ComplianceAdminDocumentsByTypeResourceToJSON,
} from './';
import type { ProviderKycData } from './';
import {
    ProviderKycDataFromJSON,
    ProviderKycDataFromJSONTyped,
    ProviderKycDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceDocumentsAdminResponse
 */
export interface ComplianceDocumentsAdminResponse {
    /**
     * 
     * @type {{ [key: string]: ProviderKycData; }}
     * @memberof ComplianceDocumentsAdminResponse
     */
    providerData: { [key: string]: ProviderKycData; };
    /**
     * Link to the KYC status on Mangopay.
     * @type {string}
     * @memberof ComplianceDocumentsAdminResponse
     * @deprecated
     */
    kycStatusLink?: string;
    /**
     * 
     * @type {Array<ComplianceAdminDocumentsByTypeResource>}
     * @memberof ComplianceDocumentsAdminResponse
     */
    documents: Array<ComplianceAdminDocumentsByTypeResource>;
    /**
     * Whether KYC simulation features are available in the current environment (dev/integration only).
     * @type {boolean}
     * @memberof ComplianceDocumentsAdminResponse
     */
    kycSimulationPossible: boolean;
}

/**
 * Check if a given object implements the ComplianceDocumentsAdminResponse interface.
 */
export function instanceOfComplianceDocumentsAdminResponse(value: object): value is ComplianceDocumentsAdminResponse {
    if (!('providerData' in value) || value['providerData'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    if (!('kycSimulationPossible' in value) || value['kycSimulationPossible'] === undefined) return false;
    return true;
}

export function ComplianceDocumentsAdminResponseFromJSON(json: any): ComplianceDocumentsAdminResponse {
    return ComplianceDocumentsAdminResponseFromJSONTyped(json, false);
}

export function ComplianceDocumentsAdminResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceDocumentsAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'providerData': (mapValues(json['providerData'], ProviderKycDataFromJSON)),
        'kycStatusLink': json['kycStatusLink'] == null ? undefined : json['kycStatusLink'],
        'documents': ((json['documents'] as Array<any>).map(ComplianceAdminDocumentsByTypeResourceFromJSON)),
        'kycSimulationPossible': json['kycSimulationPossible'],
    };
}

export function ComplianceDocumentsAdminResponseToJSON(value?: ComplianceDocumentsAdminResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'providerData': (mapValues(value['providerData'], ProviderKycDataToJSON)),
        'kycStatusLink': value['kycStatusLink'],
        'documents': ((value['documents'] as Array<any>).map((v) => ComplianceAdminDocumentsByTypeResourceToJSON(v))),
        'kycSimulationPossible': value['kycSimulationPossible'],
    };
}

